import React, { useEffect } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { SettingsIcons } from "../../assets/images";
// Redux imports
import { Sponsor } from "../../interfaces/sponsor";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  setFilterSponsorTotalPages,
  setSponsorListLoading,
} from "../../store/slices/sponsorSlices";
// API imports
import { useGetFilterSponsorListMutation } from "../../services/Sponsor";

interface Props {
  show?: boolean;
  setShow?: any;
  setSponsors?: any;
  filterSearch: boolean;
  setFilterSearch: any;
  sponsors: Sponsor[];
  query: string;
  filterInput: FormProps;
  setFilterInput: any;
}

export interface FormProps {
  city: string;
  country: string;
  companyStatus: string;
}

const SponsorFilterModal = ({
  show,
  setShow,
  sponsors,
  setSponsors,
  setFilterSearch,
  query,
  filterInput,
  setFilterInput,
  filterSearch,
}: Props) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.sponsor);
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);
  const [getFilterSponsorList] = useGetFilterSponsorListMutation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(setSponsorListLoading(true));
    setFilterSearch(true);
    setShow(false);
    // Filter employees based on the form values
    try {
      const data = {
        userID: userID || "",
        accessToken: accessToken || "",
        permission: profileData?.permissions.showProject || false,
        payload: {
          page: state.filterSponsorPageNo,
          limit: state.filterSponsorPageSize,
          city: filterInput.city,
          country: filterInput.country,
          companyStatus: filterInput.companyStatus,
        },
      };
      const response = await getFilterSponsorList(data).unwrap();
      if (response) {
        setSponsors(response.data.companys[0].data);
        dispatch(
          setFilterSponsorTotalPages(
            response.data.companys[0].metadata[0].total,
          ),
        );
      }
    } catch (e: any) {
    } finally {
      dispatch(setSponsorListLoading(false));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      dispatch(setSponsorListLoading(true));
      // Filter employees based on the form values
      try {
        const data = {
          userID: userID || "",
          accessToken: accessToken || "",
          permission: profileData?.permissions.showProject || false,
          payload: {
            page: state.filterSponsorPageNo,
            limit: state.filterSponsorPageSize,
            companyId: query,
            city: filterInput.city,
            country: filterInput.country,
            companyStatus: filterInput.companyStatus,
          },
        };
        const response = await getFilterSponsorList(data).unwrap();
        if (response) {
          setSponsors(response.data.companys[0].data);
          dispatch(
            setFilterSponsorTotalPages(
              response.data.companys[0].metadata[0].total,
            ),
          );
        }
      } catch (e: any) {
      } finally {
        dispatch(setSponsorListLoading(false));
      }
    };
    if (filterSearch) {
      fetchData();
    }
  }, [state.filterSponsorPageNo, state.filterSponsorPageSize, query]);

  const handleReset = () => {
    setSponsors(sponsors);
    setFilterInput({
      city: "",
      country: "",
      companyStatus: "",
    });
  };

  return (
    <>
      <Modal
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        className="general-modal"
      >
        <Modal.Body className="text-center px-5">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h4 className="heading">Filter Sponsor List</h4>
            <button className="btn p-0 border-0" onClick={() => setShow(false)}>
              <img src={SettingsIcons.CrossIcon} alt="edit-icon" />
            </button>
          </div>
          <div className="change-password">
            <Form onSubmit={handleSubmit} className="text-end">
              <Row>
                <Col sm="12">
                  <Form.Group
                    className="mb-3 text-start"
                    controlId="formBasicEmail"
                  >
                    <h4
                      className="sub-heading normal-font-weight textBlack"
                      style={{ fontSize: "18px" }}
                    >
                      Company Status
                    </h4>
                    <Form.Select
                      name="companyStatus"
                      onChange={(e) =>
                        setFilterInput({
                          ...filterInput,
                          companyStatus: e.target.value,
                        })
                      }
                      value={filterInput.companyStatus}
                      className="custom-input border-fill"
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="In-active">In-active</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <div className="mt-4">
                <button
                  className="btn primary-button text-center w-25 me-2"
                  onClick={handleReset}
                  type="button"
                >
                  Reset
                </button>
                <button
                  className="btn primary-button text-center w-25"
                  type="submit"
                >
                  Filter
                </button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SponsorFilterModal;
